export const regExpValidationConstants = {
  URL: 'https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
  EMAIL: /^[a-zA-Z0-9][a-zA-Z0-9_\.\-\+]{2,32}@[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]{2,6}){1,3}$/,
  PASSWORD: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[A-Z])\S{6,}$/,
  PHONE: /^[()+\-0-9 ]*$/,
  CPF: /^([-\.\s]?(\d{3})){3}[-\.\s]?(\d{2})$/,
};
